import WelcomeStep from './steps/WelcomeStep';
import PersonalStep from './steps/PersonalStep';
import ContactStep from './steps/ContactStep';
import EducationStep from './steps/EducationStep';
import SkillsStep from './steps/SkillsStep';
import ExperienceStep from './steps/ExperienceStep';
import AiJourneyStep from './steps/AiJourneyStep';
import WorkStyleStep from './steps/WorkStyleStep';
import ScenariosStep from './steps/ScenariosStep';
import CareerGoalsStep from './steps/CareerGoalsStep';
import BuilderMindsetStep from './steps/BuilderMindsetStep';
import InternshipPrefsStep from './steps/InternshipPrefsStep';
import DepartmentPrefsStep from './steps/DepartmentPrefsStep';
import FinalReflectionStep from './steps/FinalReflectionStep';
import ConsentStep from './steps/ConsentStep';
import ReviewStep from './steps/ReviewStep';
import CompleteStep from './steps/CompleteStep';
import {
  makeSelectionStep,
  STRENGTHS_SPEC,
  INTERESTS_SPEC,
  INDUSTRIES_SPEC,
  PERCEPTION_SPEC,
} from './steps/SelectionStep';

/**
 * Maps a section key to the component that renders it.
 *
 * Order, labels and which sections are optional all come from the server
 * (/api/onboarding/config) so the journey cannot drift out of step with the
 * validation and completion rules behind it. This file only answers "what
 * draws this section".
 *
 * Adding a step: add it to backend/config/onboarding/sections.js, add a
 * validator, then add one line here.
 */
export const STEP_COMPONENTS = {
  welcome: WelcomeStep,
  personal: PersonalStep,
  contact: ContactStep,
  education: EducationStep,
  skills: SkillsStep,
  experience: ExperienceStep,
  ai_journey: AiJourneyStep,
  work_style: WorkStyleStep,
  strengths: makeSelectionStep(STRENGTHS_SPEC),
  scenarios: ScenariosStep,
  interests: makeSelectionStep(INTERESTS_SPEC),
  career_goals: CareerGoalsStep,
  industries: makeSelectionStep(INDUSTRIES_SPEC),
  builder_mindset: BuilderMindsetStep,
  perception: makeSelectionStep(PERCEPTION_SPEC),
  internship_prefs: InternshipPrefsStep,
  department_prefs: DepartmentPrefsStep,
  final_reflection: FinalReflectionStep,
  consent: ConsentStep,
  review: ReviewStep,
  complete: CompleteStep,
};

/** Copy for the primary button, so it reads like progress rather than a form. */
export const CONTINUE_LABELS = {
  welcome: 'Let’s begin',
  consent: 'Review my profile',
  review: 'Submit my profile',
};

/**
 * Shown briefly after finishing a section. Keyed by the section just
 * completed, so encouragement lands at genuine milestones instead of firing
 * on every single click.
 */
export const MILESTONES = {
  contact: 'Basics done — the interesting part starts now',
  skills: 'Your skills are on your profile',
  work_style: 'That’s the longest section behind you',
  interests: 'Over halfway',
  perception: 'Almost there',
  department_prefs: 'Direction chosen',
};
